import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { OrganizationTreeSelect } from "@/modules/organization-cross-access/components/OrganizationTreeSelect";
import { EmptyState } from "@/shared/components/EmptyState";
import { PageHeader } from "@/shared/components/PageHeader";
import { useUrlTableState } from "@/shared/hooks/useUrlState";
import { PlantsTable } from "../components/PlantsTable";
import { usePlantsStore } from "../store/plants.store";

export function PlantsPage() {
	// Selected org lives in the URL; changing it also resets the table page param.
	const { getFilter, setFilters } = useUrlTableState();
	const orgId = getFilter("org");
	const openCreateModal = usePlantsStore((s) => s.openCreateModal);

	return (
		<div className="space-y-4">
			<PageHeader
				title="Ekinlar"
				action={
					<div className="flex items-center gap-2">
						<div style={{ width: 260 }}>
							<OrganizationTreeSelect
								value={orgId}
								onChange={(id) => setFilters({ org: id ?? null })}
							/>
						</div>
						<Button
							type="primary"
							icon={<PlusOutlined />}
							disabled={!orgId}
							onClick={() => orgId && openCreateModal(orgId)}
						>
							Qo'shish
						</Button>
					</div>
				}
			/>
			{orgId ? (
				<PlantsTable organizationId={orgId} />
			) : (
				<EmptyState description="Ekinlarni ko'rish uchun tashkilotni tanlang" />
			)}
		</div>
	);
}
